module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [(_vm.loading) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('static.module.subscribe.title')) + " "), _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('el-table', {
    staticClass: "selected-products",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px"
    },
    attrs: {
      "data": _vm.list,
      "empty-text": _vm.$t('static.bulkAddProducts.selectedProducts.noneSelected')
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "60px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.bulkAddProducts.selectedProducts.productName')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.name) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.bulkAddProducts.selectedProducts.batch'),
      "width": "170px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.batches.length) ? _c('el-select', {
          attrs: {
            "placeholder": "Select"
          },
          on: {
            "change": function($event) {
              return _vm.updateBatch(scope.row.id, $event)
            }
          },
          model: {
            value: (scope.row.batchId),
            callback: function($$v) {
              _vm.$set(scope.row, "batchId", $$v)
            },
            expression: "scope.row.batchId"
          }
        }, _vm._l((scope.row.batches), function(item) {
          return _c('el-option', {
            key: item.id,
            attrs: {
              "label": item.name,
              "value": item.id
            }
          })
        }), 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('el-button', {
    staticClass: "small margin-t-10",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.proceedToCreateBill
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.proceed').toUpperCase()))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6200e06b","hasScoped":false}!./src/app/components/batchAssignPopup/batchAssignPopup.html
// module id = 3037
// module chunks = 1